
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import config from "@/config/config";
import gateway from "@/lib/request/gateway";
import PostPolicy from "@/lib/model/gateway/post-policy";
import _ from "lodash-es";
import Auth from "@/lib/common/auth";
import UploadedFile from "@/lib/model/gateway/uploaded-file";

@Component({})
export default class UploadVideo extends Vue {
  @Prop({ default: "examLogoUrl", type: String }) private imgType!: string;
  @Prop({ default: "", type: String }) videoUrl!: string; //视频播放地址
  // @Prop({ default: "", type: String }) videoId!: string;
  name = "paper-list";
  loading = false;
  params = {};
  headers = {};
  postPolicy: PostPolicy = new PostPolicy();
  uploadFile: UploadedFile = new UploadedFile();

  uploader: any; //阿里云
  timeout = "";
  partSize = "";
  parallel = "";
  retryCount = "";
  retryDuration = "";
  region = "cn-shanghai";
  userId = "1303984639806000";
  file = null;
  authProgress = 0;
  uploadDisabled = true;
  resumeDisabled = true;
  pauseDisabled = true;
  statusText = "";

  uploading = false; //上传中
  uploaded = 0;
  uploadTotal = 0;

  updateStatus = false;

  get uploadUrl() {
    return _.trim(config.accountUrl) + "/api/common/uploadOss";
  }
  get token() {
    return Auth.token;
  }
  get percent() {
    return Math.floor((this.uploaded / this.uploadTotal) * 100) || 0;
  }

  @Watch("videoUrl", { immediate: true })
  onVideoUrlChange(val: string) {
    this.updateStatus = Boolean(val);
  }
  //上传
  up() {
    (this.$refs.up as any)?.click();
  }

  // afterUpload(e: any) {
  //   this.loading = false;
  //   if (e.code === 0) {
  //     this.imageUrl = e.data.url;
  //   }
  // }

  fileChange(e: any) {
    const file = e?.target?.files?.[0] as File;
    if (!file) return;
    const isMP4 = file.type.includes("mp4") || file.type.includes("MP4");
    const isLt2M = file.size / 1024 / 1024 < 500;
    if (!isMP4) {
      this.$message.warning("请上传MP4格式视频");
      return false;
    }
    if (!isLt2M) {
      this.$message.warning("视频大小不能超过500M");
      return false;
    }
    this.uploaded = 0;
    this.uploadTotal = 0;
    this.uploading = true;
    // 上传到oss
    gateway.anonymousGetPostPolicy(file.name).then((postRes: any) => {
      if (postRes) {
        const tempUrl = postRes.cdn + "/" + encodeURIComponent(postRes.dir);
        const config: any = {
          onUploadProgress: (progressEvent: any) => {
            //progressEvent.loaded:已上传文件大小
            //progressEvent.total:被上传文件的总大小
            this.uploaded = progressEvent.loaded;
            this.uploadTotal = progressEvent.total;
          }
        };
        gateway
          .upload(postRes, file, config)
          .then(() => {
            this.$emit("setVideoUrl", tempUrl);
            //获取宽高比例
            const video = document.createElement("video");
            video.onloadedmetadata = () => {
              const WH = video.videoWidth / video.videoHeight;
              this.$emit("setVideoWH", WH);
            };
            video.src = URL.createObjectURL(file);

            this.uploading = false;
            this.updateStatus = true;
          })
          .finally(() => {
            this.uploading = false;
          });
      }
    });
  }

  delImg() {
    this.$emit("setVideoUrl", "");
  }
  error() {
    console.log("error");
  }
}
